import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";
import { orderStatusType } from "./order-status-types";
import type {
    PaymentProvider} from "@@/shared/payments/payment-providers";
import {
    paymentProviderZodSchema,
} from "@@/shared/payments/payment-providers";

const orderStatusPendingPaymentConfirmationZodSchema =
    _orderStatusBaseZodSchema.merge(
        z.object({
            type: z.literal("PENDING_PAYMENT_CONFIRMATION"),
            createdBy: userIdZodSchema.or(z.string()),
            paymentProvider: paymentProviderZodSchema,
        }),
    );
type OrderPendingPaymentConfirmation = z.infer<
    typeof orderStatusPendingPaymentConfirmationZodSchema
>;

const orderStatusPendingPaymentConfirmationFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly createdBy: UserId | string;
    readonly paymentProvider: PaymentProvider;
}): OrderPendingPaymentConfirmation => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: orderStatusType.PENDING_PAYMENT_CONFIRMATION,
    createdBy: params.createdBy,
    paymentProvider: params.paymentProvider,
});

export {
    orderStatusPendingPaymentConfirmationFactory,
    orderStatusPendingPaymentConfirmationZodSchema,
};
export type { OrderPendingPaymentConfirmation };
